import { useSelector } from "react-redux";
import { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { scheduledTasksConfigurations } from "../../../../../redux/sheduled-tasks-configuration/action";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table-manager/v1.1/table";
import { selectScheduledTasksConfigurationsListItems } from "../../../../../redux/sheduled-tasks-configuration/selector";


const ManagementScheduledTasksConfigurations = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [pageData, setPageData] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const configurationsItemsData = useSelector(selectScheduledTasksConfigurationsListItems);
  const [columnDefs, setColumnDefs] = useState({});

  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(params.node.id, 10) + 1;
        },
      },
      { field: 'Name', headerName: 'Name', searchField: 'Name', sortable: true, filter: true, filterType: 'text' },

    ]);
  };

  const fetchLMSChaptersList = () => {
    dispatch(scheduledTasksConfigurations.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/system/schedule-task-configurations/list`,
      entity: 'scheduledTasksConfigurations',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc"
      }
    }));
  };

  useEffect(() => {
    createColumnDefs();
    fetchLMSChaptersList();
  }, [pageData, pageSize]);


  const handleAdd = () => {
    navigate(`${0}`);
  };



  const handleDelete = (data: any) => {
    dispatch(scheduledTasksConfigurations.delete({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/system/schedule-task-configurations/delete`,
      entity: 'scheduledTasksConfigurations',
      jsonData: {
        Records: [
          {
            id: data?.Id
          }
        ]
      }
    })).then(() => {
      fetchLMSChaptersList();
    });
  };

  const handleEdit = (data: any) => {
    navigate(`${data?.Id}`)
  }
  const handleReloadData = () => {
    fetchLMSChaptersList()
  }
  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Add Chapters</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,
      callback: () => handleAdd(),
    },

    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    },
  ];

  const handleSearch = (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Title",
        FieldText: "Title",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }

    dispatch(scheduledTasksConfigurations.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/system/schedule-task-configurations/list`,
      entity: 'scheduledTasksConfigurations',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
    }));
  };

  const back = () => {
    navigate('/management/system/scheduled-tasks')
  }

  return (
    <>
      <div className="flex items-center gap-2 px-4 py-2">
        <button
          onClick={back}
          type="button"
          className="hover:bg-gray-200 rounded-full p-2"
          title="Go back"
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="24" height="24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <h2 className="text-xl font-semibold">CONFIGURATION</h2>
      </div>

      {configurationsItemsData?.isLoading ? (
        <PageLoader />
      ) : (
        <Table
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }}
          columnData={columnDefs}
          rowData={configurationsItemsData?.result?.items}
          setPageData={setPageData}
          setPageSize={setPageSize}
          enableFilter={true}
          back={back}
          onSearch={handleSearch}
          paginationData={configurationsItemsData?.result?.pagination}
          additionButtons={additionButtons}
          onEdit={handleEdit}
          onDelete={handleDelete}
          headingName=""
        />
      )}
    </>
  );

};

export default ManagementScheduledTasksConfigurations;
